module.exports = __webpack_public_path__ + "img/flat.aba20a67.png";